import { render, staticRenderFns } from "./ent-label.vue?vue&type=template&id=451d49a6&"
import script from "./ent-label.vue?vue&type=script&lang=js&"
export * from "./ent-label.vue?vue&type=script&lang=js&"
import style0 from "./ent-label.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ent-label.vue"
export default component.exports